export enum AppointmentAvailability {
  MORNING = 'MORNING',
  LUNCH = 'LUNCH',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
}
